import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const SelectBox = styled.div`
  width: 100%;
  position: relative;
  font-size: 16px;
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`

const Tit = styled.div<{
  $active?: boolean
}>`
  color: ${props => (props.$active ? '#333336' : '#6c6c6c')};
  box-sizing: border-box;
  cursor: pointer;
  text-indent: 20px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEdSURBVHgB7dfLbcJAFIVhvwpICZSQFiglO8sFWd6lFFpICZSQAvxI/siWImRmbM+93nC+DUZg5vyCDVkmIiIiIiJe6rq+NE3znp2MMzk79r4i9CIfUJblrSiK25kRnMWZnB2LCAZUVfWZ5/nl9/LtrIhlPGdyNhtC7w8G9H3/MU3TfX7qHvF/PM85mw2he/IsYvkZzd8EvsdxvLZt+5UZWhs/DMO167p76L5oALwjjo7HpgB4RaSMx+YAWEekjseuAFhFWIzH7gCkRliNx6EAHI2wHI/DAdgbYT0eSQHYGuExHskBiEV4jYdJAJ5FcOE1HmYBWIuYH13GwzQAKxF/PMbDPACPEV7j4RKAJYJrr/HuiNjyt1BEREREXtQPat86E/bIXSgAAAAASUVORK5CYII=)
    95% / 24px 24px no-repeat;
  border: 1px solid #cececf;
  border-radius: 12px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56px;
  display: flex;
  position: relative;
  border-color: ${props => (props.$active ? '#6c6c6c' : '#cececf')};
  @media screen and (max-width: 767px) {
    height: 48px;
  }
`

const OptBox = styled.div`
  border: 1px solid #6c6c6c;
  box-sizing: border-box;
  border-radius: 12px;
  background: #ffffff;
  padding: 4px;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  z-index: 100;
  @media screen and (max-width: 767px) {
    top: 50px;
  }
`

const OptItem = styled.div<{
  $active?: boolean
}>`
  height: 48px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 12px;
  text-indent: 20px;
  cursor: pointer;
  &:hover {
    background: #f2f2f2;
  }
  background: ${props => (props.$active ? '#f2f2f2' : 'transparent')};
`

interface SelectProps {
  defaultValue: string
  options: {
    value: string
    label: string
  }[]
  placeholder?: string
  onChange: (item: { value: string; label: string }) => void
  className?: string
}

const Select = (props: SelectProps) => {
  const { defaultValue, options, onChange, placeholder = '', className } = props
  const [active, setActive] = useState(false)
  const eventRef = useRef<(e: MouseEvent) => void>((e: MouseEvent) => {
    const target = e.target as HTMLElement
    if (!target.closest('[data-select="select-box"]')) {
      setActive(false)
    }
  })
  useEffect(() => {
    const handleClick = eventRef.current
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])
  return (
    <SelectBox data-select='select-box'>
      <Tit
        $active={active}
        className={className || ''}
        onClick={() => {
          setActive(!active)
        }}
      >
        {defaultValue || placeholder}
      </Tit>
      {active && (
        <OptBox>
          {options.map(item => {
            return (
              <OptItem
                $active={defaultValue === item.value}
                key={item.value}
                onClick={() => {
                  onChange(item)
                  setActive(false)
                }}
              >
                {item.label}
              </OptItem>
            )
          })}
        </OptBox>
      )}
    </SelectBox>
  )
}

export default Select
